import { CSSInterpolation } from '@mui/material';

import { globalTheme } from '../../../../../../../shared/theme/theme';
import { tableBlack, tableBorderColor } from '../variables/variables';

export const tableCellInterpolation: CSSInterpolation = {
  height: '40px',
  color: tableBlack,
  borderBottom: `1px solid ${globalTheme.palette.appGrey.greyPrimary}`,
  padding: '20px 0',
  verticalAlign: 'middle',
  position: 'relative',
  fontSize: '16px',

  'span.table-multiselect-checkbox': {
    padding: 0,
    position: 'absolute',
    top: '50%',
    left: '-2px',
    transform: 'translate(0, -50%)',

    input: {
      '& + svg': {
        color: globalTheme.palette.primary.main,
      },

      '&:not(:checked)': {
        '& + svg': {
          color: tableBorderColor,
        },
      },

      '&[data-indeterminate="true"] + svg': {
        color: globalTheme.palette.primary.main,
      },
    },
  },
};
